import React, { useCallback } from 'react';
import PollOption from './PollOption';
import s from './PollView.scss';
var PollAnswers = function (_a) {
    var poll = _a.poll, canVote = _a.canVote, onVote = _a.onVote, minimal = _a.minimal, draftJsThemeOverride = _a.draftJsThemeOverride, answerClassName = _a.answerClassName;
    var _onVote = useCallback(function (answerId) {
        if (!poll) {
            return;
        }
        onVote({ pollId: poll.pollId, userId: poll.user.userId, answerId: answerId });
    }, [onVote, poll]);
    return (React.createElement(React.Fragment, null, poll &&
        poll.answers.map(function (answer) { return (React.createElement(PollOption, { className: s['poll-option'], answer: answer, canVote: canVote, onClick: _onVote, key: answer.answerId, minimal: minimal, draftJsThemeOverride: draftJsThemeOverride, answerClassName: answerClassName })); })));
};
PollAnswers.displayName = 'PollAnswers';
export default PollAnswers;
//# sourceMappingURL=PollAnswers.js.map